import { Component, OnInit, ViewChild } from '@angular/core';
import { Http } from '@angular/http';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import {Pipe} from '@angular/core';
import {IOption} from 'ng-select';
declare  const $;
import {ToastyService, ToastyConfig, ToastOptions, ToastData} from 'ng2-toasty';
import * as moment from 'moment/moment';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { AlertComponent } from './../alert/alert.component';
import { Popup } from 'ng2-opd-popup';

@Component({
  selector: 'app-add-mail',
  templateUrl: './add-mail.component.html',
  styleUrls: ['./add-mail.component.scss']
})
export class AddMailComponent implements OnInit {
  btnName:any='Submit';
  isValid:boolean = true;
	ListAddMailDetails:any[] = [];
	msgtext:any;
	startingCount:number = 0;
	endingCount:number = 0;
	p: number = 1;
	addMail:string;
	newaddMail_err:boolean=false;
	EditObjectId:any;
	@ViewChild('add') add: Popup;
 	@ViewChild('update') update: Popup;
	@ViewChild('Askdelete') Askdelete: Popup;
	@ViewChild('delete') delete: Popup;
	deleteId:any;
	orgId:number;
	userId:number;
  loading:boolean=false;
  //basePath = 'https://www2.cognitivemobile.net/pilot';
  basePath = 'https://www1.cognitivemobile.net/ASE';
  reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{1,4})$/;
  constructor(private dialogService:DialogService,private http: Http,private toastyService:ToastyService,private toastyConfig: ToastyConfig,private router:Router,private route : ActivatedRoute) { }

  ngOnInit() {
    //this.loading=true;
		if(this.route.params['value'].orgId === '' || this.route.params['value'].orgId === undefined || this.route.params['value'].orgId === null || this.route.params['value'].userId === undefined || this.route.params['value'].userId === '' || this.route.params['value'].userId === null){
	    	window.location.href = 'https://still.alshirawi.com/highmessaging/';
	    } else {
	      this.orgId=this.route.params['value'].orgId;
	      this.userId=this.route.params['value'].userId;
	      console.log('OrgId '+ this.orgId);
	      console.log('UserId '+ this.userId);
		}
		this.getMailDetails();
  }

  InputaddMail(value) {
    if(this.addMail == "" || this.addMail == null || this.addMail == undefined) {
			this.isValid=true;
		} else if(this.reg.test(this.addMail) == false) {
      this.newaddMail_err = true;
      this.isValid = true;
    }else {
      this.newaddMail_err=false;
			this.isValid=false;
		}
	}

  showAlertForAddingdata(){
		this.dialogService.addDialog(AlertComponent,{title:"ADD Mail-Id",message:"The Data added successfully"});
	}
	
	showAlertForUpdatingdata(){
		this.dialogService.addDialog(AlertComponent,{title:"UPDATE Mail-Id",message:"The Data updated successfully"});
	}
	showAlertForDeletingdata(){
		this.dialogService.addDialog(AlertComponent,{title:"DELETE Mail-Id",message:"The Data deleted successfully"});
	}
	addOk() {
		this.add.hide();
	}

	updateOk() {
		this.update.hide();
	}

	deleteOk() {
		this.delete.hide();
  }
  
  getCount(){
    if(this.p < Math.ceil(this.ListAddMailDetails.length/10)){
      this.startingCount = (this.p-1)*10;
      if(this.startingCount == 0){
        this.startingCount = 1;
      }
      this.endingCount = this.p*10;
      console.log('List Length '+ this.ListAddMailDetails.length);
      console.log('List startingCount '+ this.startingCount);
      console.log('List endingCount '+ this.endingCount);
    } else if(this.p == Math.ceil(this.ListAddMailDetails.length/10)){
      let count = this.ListAddMailDetails.length%10;
      this.startingCount = (this.p-1)*10;
      this.endingCount = this.startingCount + count;
      if(this.startingCount == 0){
        this.startingCount = 1;
        this.endingCount = count;
      }
      console.log('List Length '+ this.ListAddMailDetails.length);
      console.log('List startingCount '+ this.startingCount);
      console.log('List endingCount '+ this.endingCount);
    }
   }

   getMailDetails() {
   
	return this.http.get(this.basePath+'/getBodyShopSendMailListDetails?userId='+this.userId+'').subscribe(
		res=>{
			let Respone = res.json();
			this.ListAddMailDetails = Respone.email_list_array;
	},(err)=>{
		alert(err)
	})
    
  }

  addMailValue() {
	this.loading=true;
	if(this.addMail == "" || this.addMail == undefined || this.addMail == null || this.isValid==true) {
		this.newaddMail_err=true;
		this.loading=false;
	} else {
	    if(this.EditObjectId == null || this.EditObjectId == undefined || this.EditObjectId == "") {
		  let reqMakeObj = {
			"userId":this.userId,
			"orgId":this.orgId,
			"emailName":this.addMail.toLowerCase(),
			"reportName": "virReport",
			"priority":2
		  }
		  return this.http.post(this.basePath+'/saveOrUpdateOrDeleteBodyShopSendMailDetails', reqMakeObj).subscribe(
		  res => {
			  let mailResponse = res.json();
			  if(mailResponse.hasOwnProperty('result_text')) {
				if(mailResponse.result_text == "Saved") {
					this.loading=false;
					alert('Mail-Id Added Successfully');
				    this.getMailDetails();
				} else {
					this.loading=false;
					alert(mailResponse.result_text);
				}
			  } else {
				this.loading=false;
				alert(mailResponse.result_text);
			  }
		  },(err) =>{
			  this.loading=false;
			  if(err.status != 200){
				this.msgtext = "Unable to Add the Mail Value";
				this.getWarningFunction(this.msgtext);
			  }
		  })
	  } else {
		 	let reqMakeObj = {
				"userId":this.userId,
				"orgId":this.orgId,
				"emailName":this.addMail.toLowerCase(),
				"reportName": "virReport",
				"emailId":this.EditObjectId,
				"priority":2
			}
			return this.http.post(this.basePath+'/saveOrUpdateOrDeleteBodyShopSendMailDetails', reqMakeObj).subscribe(
			res => {
			  let mailResponse = res.json();
			  if(res.hasOwnProperty('result_text')) {
				if(mailResponse.result_text == "Updated") {
					alert('Mail-Id UPdated Successfully');
				} else {
				  
				}
			  } else {
				
			  }
			},(err) =>{
			  this.loading=false;
			  if(err.status != 200){
				this.msgtext = "Unable to Add the make Value";
				this.getWarningFunction(this.msgtext);
			  }
			})
	  }

  }
  
}

getWarningFunction(errMsg) {
	var toastOptions:ToastOptions = {
		title: "Make",
		msg: errMsg,
		showClose: true,
		timeout: 3000,
		theme: 'bootstrap',
		onAdd: (toast:ToastData) => {
		},
		onRemove: function(toast:ToastData) {
		}
	};
	this.toastyService.warning(toastOptions);
}//getWarningFunction end here


getSuccessFunction(successMsg){
var toastOptions:ToastOptions = {
  title: "Make",
  msg: successMsg,
  showClose: true,
  timeout: 3000,
  theme: 'bootstrap',
  onAdd: (toast:ToastData) => {
  },
  onRemove: function(toast:ToastData) {
  }
};
this.toastyService.success(toastOptions);
}//getSuccessFunction end here

}



// WEBPACK FOOTER //
// ./client/app/add-mail/add-mail.component.ts